import h from 'react-hyperscript';

import Overlay from './Overlay';

export default () => h(Overlay, { type: 'SUBSCRIPTION_ENDED' });



// WEBPACK FOOTER //
// ./src/components/Overlay/OverlaySubscriptionEnded.js